import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/KhmDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export interface KmTransData{
  idx : number;
  crw_idx : number;
  topic_cd : string;
  data_type_cd : string;
  created_date : string;
  seq : string;
  mgm_pk : string;
  issue_date : string;
  writer_ko : string;
  writer_km : string;
  copyrighter_ko : string;
  copyrighter_km : string;
  org_ext : string;
  data_src : string;

  url: string;
  kwd_km: string;
  kwd_ko: string;
  kwd_en: string;
  title_km: string;
  title_ko: string;
  title_en: string;
  text_km: string;
  text_ko: string;
  text_en: string;

  wrd_cnt : string;
  file_size : string;
  
  prc_json : string;
  prc_yn : string;
  prc_date : string;
  
  isp1_user : string;
  isp1_yn : string;
  isp1_date : string;
  isp1_rsn : string;
  isp1_rsn_cd : string;
  
  isp2_user : string;
  isp2_yn : string;
  isp2_date : string;
  isp2_rsn : string;
  
  ins_date : string;

  instruction_yn : string;
}

export interface DetailCat{
  idx: number;
  crw_idx: number;
  
  kwd_km: string;
  kwd_ko: string;
  kwd_en: string;
}

export interface DetailCrw{
  idx: number;
  site_name: string;
  url: string;
  title_km: string;
  text_km: string;
}

// const initailCatDetailData: DetailCat = {
//   idx: -1,
//   crw_idx: -1,
  
//   kwd_km: "",
//   kwd_ko: "",
//   kwd_en: "",
// }


const initailKmTransData: KmTransData = {
  idx : -1,
  crw_idx : -1,
  topic_cd : "",
  data_type_cd : "",
  created_date : "",
  seq : "",
  mgm_pk : "",
  issue_date : "",
  writer_ko : "",
  writer_km : "",
  copyrighter_ko : "",
  copyrighter_km : "",
  org_ext : "",
  data_src : "",

  url: "",
  kwd_km: "",
  kwd_ko: "",
  kwd_en: "",
  title_km: "",
  title_ko: "",
  title_en: "",
  text_km: "",
  text_ko: "",
  text_en: "",

  wrd_cnt : "",
  file_size : "",
  
  prc_json : "",
  prc_yn : "",
  prc_date : "",
  
  isp1_user : "",
  isp1_yn : "",
  isp1_date : "",
  isp1_rsn : "",
  isp1_rsn_cd : "",
  
  isp2_user : "",
  isp2_yn : "",
  isp2_date : "",
  isp2_rsn : "",
  
  ins_date : "",
  instruction_yn: "",
};

const KhmISPDialog = (props: any) => {

  const [prc_data, setPrc_data] = useState<KmTransData>(initailKmTransData);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [open_pop, setOpen_pop] = useState(false);
  const [placement, setPlacement] = useState<PopperPlacementType>();

  const handleClick =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen_pop((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  const [l_select, setL_select] = useState("KM")

  const [r_select, setR_select] = useState("EN")

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  let union_role = auth.user.roles.some((obj:any) => ['KHM_ISP'].includes(obj.role) && ['Y'].includes(obj.type));

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };

  const getPrcDetail = async (idx: number) => {
    var result = await api.get("/km-prc-detail",{params:{email:email,idx:idx}});
    setPrc_data(result.data.datas[0])
  };

  const updateInstructionYn = async (v: boolean) => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("idx", prc_data.idx.toString());

    formData.append("instruction_yn", (v == true ? "Y" : "N"));

    let alert_message = (v == true ? "Instruction 대상 설정 완료" : "Instruction 대상 해제 완료")

    // setPrc_data({ ...prc_data, topic_cd: e.target.value })

    await api.post("/km-instruction-update",formData)
    .then((res:any) => { alert(alert_message); setPrc_data({ ...prc_data, instruction_yn: res.data }) })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  }

  const saveImsi = async () => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("idx", prc_data.idx.toString());

    formData.append("topic_cd", prc_data.topic_cd);

    // formData.append("datas", JSON.stringify(prc_data));

    await api.post("/km-isp-update-imsi",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다.(임시저장 - 검수X)"); props.updateAfter(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const saveIsp1Data = async () => {

    let isp1_yn = 'Y'

    if(prc_data.isp1_rsn_cd != "None"){
      isp1_yn = 'N'
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("isp1_yn", isp1_yn);

    formData.append("idx", prc_data.idx.toString());

    formData.append("isp1_rsn_cd", prc_data.isp1_rsn_cd);

    formData.append("isp1_rsn", prc_data.isp1_rsn);

    formData.append("topic_cd", prc_data.topic_cd);

    await api.post("/km-isp-update-new",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.updateAfter(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }


  useEffect(() => {
    getAuths();
    // setData(initailData);
    // setData(props.rowDetail);
    if(props.rowDetail != undefined){
      getPrcDetail(props.rowDetail.idx)
      // getCatDetail(props.rowDetail.crw_idx)
      // getCrwDetail(props.rowDetail.crw_idx)
      // getTrsDetail(props.rowDetail.crw_idx)
    }
  }, [props.rowDetail]);

  if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (

    <Paper sx={{width:"100%", overflow: "auto"}}>
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 정보</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

          <Box display="flex">
            <>
            {l_select == "KM" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KM</Box> */}
                          <Select id="l_select" value={l_select || "KM"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"KM"}>KM</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"540px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}><b style={{fontFamily: "Khmer OS, serif"}}>វប្បធម៌,សិល្បៈ,ការអប់រំ</b></MenuItem>
                              <MenuItem dense value={"102"}><b style={{fontFamily: "Khmer OS, serif"}}>ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍</b></MenuItem>
                              <MenuItem dense value={"103"}><b style={{fontFamily: "Khmer OS, serif"}}>កីឡា,ផ្សេងៗ</b></MenuItem>
                              <MenuItem dense value={"204"}><b style={{fontFamily: "Khmer OS, serif"}}>សង្គម,ឧស្សាហកម្ម</b></MenuItem>
                              <MenuItem dense value={"205"}><b style={{fontFamily: "Khmer OS, serif"}}>នយោបាយ,សេដ្ឋកិច្ច</b></MenuItem>
                              <MenuItem dense value={"206"}><b style={{fontFamily: "Khmer OS, serif"}}>វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ</b></MenuItem>
                              <MenuItem dense value={"307"}><b style={{fontFamily: "Khmer OS, serif"}}>ទំនៀមទម្លាប,ទម្លាប់</b></MenuItem>
                              <MenuItem dense value={"408"}><b style={{fontFamily: "Khmer OS, serif"}}>ជីវិតប្រចាំថ្ងៃ , អាហារ</b></MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_km} spellCheck="false" style={{width:"534px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_km} spellCheck="false" style={{width:"664px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_km} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
            }
            {l_select == "KO" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                          <Select id="l_select" value={l_select || "KO"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"KM"}>KM</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"540px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                              <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                              <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                              <MenuItem dense value={"204"}>사회,산업</MenuItem>
                              <MenuItem dense value={"205"}>정치,경제</MenuItem>
                              <MenuItem dense value={"206"}>과학,의학</MenuItem>
                              <MenuItem dense value={"307"}>관습,의례</MenuItem>
                              <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_ko || ""} spellCheck="false" style={{width:"534px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_ko || ""} spellCheck="false" style={{width:"664px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_ko || ""} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
            {l_select == "EN" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                          <Select id="l_select" value={l_select || "EN"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"KM"}>KM</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"540px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                              <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                              <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                              <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                              <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                              <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                              <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                              <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_en || ""} spellCheck="false" style={{width:"534px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_en || ""} spellCheck="false" style={{width:"664px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_en || ""} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
            </>
            {/*  :""} */}

            {/* {trsDetail ?  */}
            <>
            {r_select == "KM" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KM</Box> */}
                          <Select id="r_select" value={r_select || "KM"} onChange={(e) => {setR_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"KM"}>KM</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"540px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                            <MenuItem dense value={"101"}><b style={{fontFamily: "Khmer OS, serif"}}>វប្បធម៌,សិល្បៈ,ការអប់រំ</b></MenuItem>
                              <MenuItem dense value={"102"}><b style={{fontFamily: "Khmer OS, serif"}}>ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍</b></MenuItem>
                              <MenuItem dense value={"103"}><b style={{fontFamily: "Khmer OS, serif"}}>កីឡា,ផ្សេងៗ</b></MenuItem>
                              <MenuItem dense value={"204"}><b style={{fontFamily: "Khmer OS, serif"}}>សង្គម,ឧស្សាហកម្ម</b></MenuItem>
                              <MenuItem dense value={"205"}><b style={{fontFamily: "Khmer OS, serif"}}>នយោបាយ,សេដ្ឋកិច្ច</b></MenuItem>
                              <MenuItem dense value={"206"}><b style={{fontFamily: "Khmer OS, serif"}}>វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ</b></MenuItem>
                              <MenuItem dense value={"307"}><b style={{fontFamily: "Khmer OS, serif"}}>ទំនៀមទម្លាប,ទម្លាប់</b></MenuItem>
                              <MenuItem dense value={"408"}><b style={{fontFamily: "Khmer OS, serif"}}>ជីវិតប្រចាំថ្ងៃ , អាហារ</b></MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_km || ""} spellCheck="false" style={{width:"534px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_km || ""} spellCheck="false" style={{width:"664px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_km || ""} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
            }
            {r_select == "KO" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                          <Select id="r_select" value={r_select || "KO"} onChange={(e) => {setR_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"KM"}>KM</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"540px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                              <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                              <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                              <MenuItem dense value={"204"}>사회,산업</MenuItem>
                              <MenuItem dense value={"205"}>정치,경제</MenuItem>
                              <MenuItem dense value={"206"}>과학,의학</MenuItem>
                              <MenuItem dense value={"307"}>관습,의례</MenuItem>
                              <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_ko || ""} spellCheck="false" style={{width:"534px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_ko || ""} spellCheck="false" style={{width:"664px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_ko || ""} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
            {r_select == "EN" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                          <Select id="r_select" value={r_select || "EN"} onChange={(e) => {setR_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"KM"}>KM</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"540px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                              <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                              <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                              <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                              <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                              <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                              <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                              <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_en || ""} spellCheck="false" style={{width:"534px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_en || ""} spellCheck="false" style={{width:"664px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_en || ""} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
          
          </>
        {/* : ""} */}

        
        </Box>

        <Box>
          <Box sx={{width:"100%",marginTop:"20px"}}>
            <Box justifyContent="left" sx={{alignItems: "center", marginLeft:"16px"}}>
              <Box sx={{fontWeight:700, width:"90px", fontSize:"18px"}}>부적합코드</Box>
              <Select id="isp1_rsn_cd" value={prc_data.isp1_rsn_cd || "None"} onChange={(e) => {setPrc_data({ ...prc_data, isp1_rsn_cd: e.target.value });}} sx={{fontSize:"14px", height: "28px", fontWeight:700, textAlign:"center"}}>
                <MenuItem dense value={"None"}>선택안함</MenuItem>
                <MenuItem dense value={"01"}>01.캄보디아와 관련없는 내용</MenuItem>
                <MenuItem dense value={"02"}>02.원문 품질 부적합</MenuItem>
                {/* <MenuItem dense value={"03"}>03.한국어/영어 부적합</MenuItem>
                <MenuItem dense value={"04"}>04.한국어 부적합</MenuItem>
                <MenuItem dense value={"05"}>05.영어 부적합</MenuItem>
                <MenuItem dense value={"09"}>09.직접입력</MenuItem> */}
              </Select>
              <Button onClick={handleClick('right-start')}><HelpOutlineIcon/></Button>
              <Popper
                // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
                sx={{ zIndex: 1300}}
                open={open_pop}
                anchorEl={anchorEl}
                placement={placement}
                transition
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={1}>
                    <Paper sx={{fontSize:"14px"}}>
                      <Box sx={{ p: 1 }}>01. <b style={{color:"blue"}}>캄보디아와 관련없는 내용</b> - 원문 전체가 탄자니아가 아닌 타 국가와 관련된 내용임</Box>
                      <Box sx={{ p: 1 }}>02. <b style={{color:"blue"}}>원문 품질 부적합</b> - 원문이 정상적이지 않은 경우 (특별한 내용없음, 광고, 정치적 성향 강조 … 등)</Box>
                      {/* <Box sx={{ p: 1 }}>03. <b style={{color:"blue"}}>한국어/영어 부적합</b> - 한국어, 영어 둘다 수정할 수 없는 수준으로 잘못 번역되었음</Box>
                      <Box sx={{ p: 1 }}>04. <b style={{color:"blue"}}>한국어 부적합</b> - 한국어가 수정할 수 없는 수준으로 잘못 번역되었음</Box>
                      <Box sx={{ p: 1 }}>05. <b style={{color:"blue"}}>영어 부적합</b> - 영어가 수정할 수 없는 수준으로 잘못 번역되었음</Box>
                      <Box sx={{ p: 1 }}>09. <b style={{color:"blue"}}>직접입력</b> - 부적합 사유를 '검수비고(사유)'란에 직접 입력하였음</Box> */}
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </Box>
            <Box justifyContent="left" sx={{alignItems: "center", marginLeft:"16px",marginTop:"16px"}}>
              <Box sx={{fontWeight:700, width:"120px", fontSize:"18px"}}>검수비고(사유)</Box>
              <Box sx={{marginLeft:"8px", fontSize:"16px", width:"220px"}}>
                <textarea value={prc_data.isp1_rsn || ""} onChange={(e) => {setPrc_data({ ...prc_data, isp1_rsn: e.target.value });}} spellCheck="false" style={{width:"100%",minHeight:"80px", fontSize:"12px", fontWeight:600,padding:"2px"}}  />
              </Box>
            </Box>
            {union_role && 
              <Box display="flex" sx={{alignItems: "center"}}>
                <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox>
                <Button variant="contained" color="secondary" size="small" sx={{minWidth:"42px",fontWeight:700, borderRadius:"42px"}}
                    onClick={() => {
                      saveImsi()
                    }}
                  >
                    저장(검수X)
                </Button>
              </Box>
            }
            <Box display="flex" justifyContent="center">
              <Button variant="contained" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"180px",height:"80px"}}
                onClick={() => {
                  saveIsp1Data();
                }}
              >
                확 인
              </Button>
            </Box>
            
          </Box>
        </Box>

      </Box>


      
      
    </Paper>
  );
};

export default KhmISPDialog;
